export default "__VITE_ASSET__DumpceAc__"